import T from "../../theme";

export const Card = ({ children, style: s = {}, hoverable, onClick }) => (
  <div
    className={hoverable ? "card-hover" : ""}
    onClick={onClick}
    style={{ background: T.card, border: `1px solid ${T.border}`, borderRadius: T.radiusMd, boxShadow: T.shadow, transition: "all 0.2s", ...s }}>
    {children}
  </div>
);
